import { memo } from 'react'

import Flyout, { TFlyoutProps } from 'common-components/Flyout'
import SlideUp from 'common-components/SlideUp'

import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

const FlyoutWithMobileSlideUp = (props: TFlyoutProps) => {
  const { isOpen, onClose, children, bottomMargin } = props

  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  if (isTablet) {
    return (
      <SlideUp isOpen={!!isOpen} onClose={onClose} bottomMargin={bottomMargin}>
        {children}
      </SlideUp>
    )
  }

  return <Flyout {...props}>{children}</Flyout>
}

export default memo(FlyoutWithMobileSlideUp)
